@if (inProgress) {
<mat-progress-bar 
         
          color="primary"
          mode="indeterminate">
</mat-progress-bar>
}
<form class="screen-video-upload-form" [formGroup]="uploadScreenVideoForm" (ngSubmit)="uploadScreenVideo()">
    <mat-form-field class="field-full-width" appearance="fill" subscriptSizing="dynamic">
      <mat-label>Video Name</mat-label>
      <input matInput placeholder="Traing video name" formControlName="videoName">
    </mat-form-field>

    <mat-form-field class="field-full-width" appearance="fill" subscriptSizing="dynamic">
      <mat-label>Video Description</mat-label>
      <textarea matInput rows="4" placeholder="Traing video description" formControlName="videoDescription"></textarea>
    </mat-form-field>

    <div class="field-full-width video-section">
        <div class="video-section__controls">
            <button class="video-button" type="button" mat-stroked-button (click)="videoFileInput.click()">
                {{screenVideoFileName || 'Choose File'}}
            </button>

            <input style="display:none;" (change)="onFileSelected()"
                #videoFileInput type="file" id="file" accept="video/*" required>

            @if (screenVideoFileName) {
            <section class="thumbnail-section">
                <mat-slider min="1" step="1"
                    [max]="selectedVideoDuration"
                    discrete>
                    <input matSliderThumb
                        [value]="selectedTime"
                        (valueChange)="selectFrame($event)">
                </mat-slider>
                <span class="chooseThumbnail">Choose a thumbnail...</span>
            </section>
            }
            <section class="is_client_specific">
                <mat-checkbox id="is_client_specific" formControlName="is_client_specific" color="primary">
                    Client Specific?
                </mat-checkbox>
            </section>
        </div>
        @if (screenVideoFileName) {
        <span class="poster-file" id="thumbnail">
            <img src="" #posterFile width="200" height="125" alt="Video thumbnail preview">
        </span>
        }
    </div>

    <section class="upload-actions">
        <button type="submit" class="upload_button" mat-raised-button color="primary"
            [disabled]="!uploadScreenVideoForm.valid">
            Save
        </button>
        <button type="button" class="clear_button" mat-stroked-button
            (click)="resetUploadScreenVideoForm()">
            Clear
        </button>
    </section>
</form>
